import { render, staticRenderFns } from "./InscriptionGradeList.vue?vue&type=template&id=76cb8c32"
import script from "./InscriptionGradeList.vue?vue&type=script&lang=js"
export * from "./InscriptionGradeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports